import { axiosEduServer } from "../utils/configAxios";

export const crearPais = (data) => {
  return axiosEduServer.post('/pais', data).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const actualizarPais = (id, data) => {
  return axiosEduServer.put(`/pais/${id}`, data).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const eliminarPais = (id) => {
  return axiosEduServer.delete(`/pais/${id}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getOnePais = (id) => {
  return axiosEduServer.get(`/pais/${id}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getAllPaises = () => {
  return axiosEduServer.get('/pais').then(({ data }) => data).catch((err) => { console.log(err); throw err });
};